<!-- Cumulative Energy (KWH) -->
<!-- <div class="d-flex" style="justify-content: space-between"> -->
    <div class="ch_box acc min_height" style="width: 50%;">
        <button class="float-end" *ngIf="generic_asset_id != ''" style="float: right;"
            (click)="openEmeterGraphSettingsDialog('CumulativeEnergyA,CumulativeEnergyB,CumulativeEnergyC',generic_asset_id)"
            class="border border-light settings-icon"><img style="width: 20px; height: 20px; cursor: pointer"
                src="./assets/settings.png" />
        </button>
        <div class="heading">Cumulative Energy (KWH)</div>
        <div class="d-flex" style="justify-content: space-around !important; ">
            <ng-container *ngIf="cumulativeenergyloading; else cumulativeenergyid">
                <div *ngFor="let i of [0,1,2]">
                    <div>
                        <div class="spinner-border text-primary" role="status"></div>
                    </div>
                </div>
            </ng-container>
            <ng-template #cumulativeenergyid>
                <div *ngFor="let CumulativeEnergy of CumulativeEnergyData">

                    <app-gauge-chart
                        matTooltip=" Cumulative Energy (KWH) Thresholds as per customer defined specific thresholds as per their process."
                        style="color: orange;color:black;" [matTooltipClass]="'tooltip'"
                        [ngClass]="'custom-css small-font'" [canvasWidth]="canvasWidth"
                        [canvasHeight]="canvasHeight"
                        [needleValue]="CumulativeEnergy.needleValue"
                        [needleColor]="CumulativeEnergy.options.needleColor" [centralLabel]="centralLabel"
                        [options]="CumulativeEnergy.options" [name]="CumulativeEnergy.name"
                        [bottomLabel]="CumulativeEnergy.bottomLabel">
                    </app-gauge-chart>
                </div>
            </ng-template>
        </div>
        
    </div>
    <div class="ch_box acc min_height" style="width: 50%;">
        <button *ngIf="generic_asset_id != ''" style="float: right;"
            (click)="openEmeterGraphSettingsDialog('3PhaseLoadCurrentA,3PhaseLoadCurrentB,3PhaseLoadCurrentC,3PhaseLoadCurrentBalancing',generic_asset_id)"
            class="border border-light settings-icon"><img style="width: 20px; height: 20px; cursor: pointer"
                src="./assets/settings.png" />
        </button>
        <div class="heading">3-Phase Load Current</div>
        <div class="d-flex" style="justify-content: space-around !important;">
            <ng-container *ngIf="threephaseloadcurrentloading; else threephaseloadcurrentid">
                <div class="inner vibrationInner" *ngFor="let i of [0,1,2]">
                    <div class="spinner-container">
                        <div class="spinner-border text-primary" role="status"></div>
                    </div>
                </div>
            </ng-container>

            <ng-template #threephaseloadcurrentid>
                <div class="inner vibrationInner" *ngFor="let em3PhaseLoadCurrent of em3PhaseLoadCurrentData">
                    <app-gauge-chart
                        matTooltip=" 3-Phase Load Current Thresholds as per customer defined specific thresholds as per their process."
                        style="color: orange;color:black;" [matTooltipClass]="'tooltip'"
                        [ngClass]="'custom-css small-font'" [canvasWidth]="canvasWidth" [canvasHeight]="canvasHeight"
                        [needleValue]="em3PhaseLoadCurrent.needleValue"
                        [needleColor]="em3PhaseLoadCurrent.options.needleColor" [centralLabel]="centralLabel"
                        [options]="em3PhaseLoadCurrent.options" [name]="em3PhaseLoadCurrent.name"
                        [bottomLabel]="em3PhaseLoadCurrent.bottomLabel">
                    </app-gauge-chart>
                </div>


            </ng-template>
        </div>
        

    </div>

    
    <div class="ch_box acc min_height" style="width: 50%;" >
        <button *ngIf="generic_asset_id != ''" style="float: right;"
           (click)="openEmeterGraphVpfSettingsDialog('3PhaseLineVoltageA,3PhaseLineVoltageB,3PhaseLineVoltageC,3PhaseLineVoltageBalancing',generic_asset_id)"
           class="border border-light settings-icon"><img style="width: 20px; height: 20px; cursor: pointer"
              src="./assets/settings.png" />
        </button>
        <div class="heading">3-Phase Line Voltage</div>
        <div class="d-flex" style="justify-content: space-around !important;">
           <ng-container *ngIf="threephaselinevoltageloading; else threephaselinevoltageid">
              <div class="inner vibrationInner" *ngFor="let i of [0,1,2]">
                 <div class="spinner-container">
                    <div class="spinner-border text-primary" role="status"></div>
                 </div>
              </div>
           </ng-container>
           <ng-template #threephaselinevoltageid>
              <div class="inner vibrationInner" *ngFor="let em3PhaseLineVoltage of em3PhaseLineVoltageData">
                 <app-gauge-chart
                    matTooltip=" 3-Phase Line Voltage Thresholds as per customer defined specific thresholds as per their process."
                    style="color: orange;color:black;" [matTooltipClass]="'tooltip'"
                    [ngClass]="'custom-css small-font remove-3rd-element'" [canvasWidth]="canvasWidth" [canvasHeight]="canvasHeight"
                    [needleValue]="em3PhaseLineVoltage.needleValue" [needleColor]="em3PhaseLineVoltage.options.needleColor"
                    [centralLabel]="centralLabel" [options]="em3PhaseLineVoltage.options" [name]="em3PhaseLineVoltage.name"
                    [bottomLabel]="em3PhaseLineVoltage.bottomLabel">
                 </app-gauge-chart>
              </div>
           </ng-template>
        </div>
     </div>
<!-- </div> -->